import "./campaign-cost-label.css";
import CoinsIcon from "../../../assets/icons/CoinsIcon";

interface CampaignCostLabelProps {
    costUsd?: number;
    estimatedCostUsd?: number;
}

const CampaignCostLabel = ({ costUsd, estimatedCostUsd }: CampaignCostLabelProps) => {
    const label = costUsd ? 'Cost' : 'Estimated Cost';
    const rounded = (num: number) => Math.round((num) * 100) / 100;
    return (
        <div className="campaign-thumb-sub-title">
            <div className="coins-icon"><CoinsIcon width={18} color='#d3d3d3' /></div>
            <span>{label}: <span>${rounded(costUsd || estimatedCostUsd || 0)}</span>{costUsd && estimatedCostUsd && costUsd !== estimatedCostUsd ? ` (Full campaign est.: $${rounded(estimatedCostUsd)})` : ''}</span>
        </div>
    );
}

export default CampaignCostLabel;